export default {
  setChangeDate (state: {[key:string]: string}, value: string) {
    state.changeDate = value
  },
  // 矢印クリックで日付を選択したかの判定
  setArrowClick (state: {[key:string]: boolean}, flag: boolean) {
    state.arrowClick = flag
  }
}
